export const DEFAULT_PRIMARY_COLOR = '#566367';
export const DEFAULT_ACCENT_COLOR = '#64b32c';
export const DEFAULT_WARNING_COLOR = '#FFA724FF';
export const DEFAULT_ERROR_COLOR = '#e34a4a';

export const MERKUR_PALETTE_GV = '#97e65e';
export const MERKUR_PALETTE_LV = '#9b96b4';
export const MERKUR_PALETTE_UV = '#f08c8c';
export const MERKUR_PALETTE_SV = '#87c8cd';

export const MERKUR_PALETTE_EXTRA_1 = '#c3b49b';
export const MERKUR_PALETTE_EXTRA_2 = '#f5aa82';
export const MERKUR_PALETTE_EXTRA_3 = '#3c413c';

export const BLACK = '#000000';
export const WHITE = '#ffffff';

export function getColorForSparte(sparte: string, asHexCode = false): string {
  if (typeof sparte === 'string') {
    switch (sparte.slice(0, 1).toLowerCase()) {
      case 'g':
        return gvColor(asHexCode);
      case 'l':
        return lvColor(asHexCode);
      case 'u':
        return uvColor(asHexCode);
      case 's':
        return svColor(asHexCode);
      default:
        return '';
    }
  } else {
    switch (sparte) {
      case 'G':
        return gvColor(asHexCode);
      case 'L':
        return lvColor(asHexCode);
      case 'U':
        return uvColor(asHexCode);
      case 'S':
        return svColor(asHexCode);
      default:
        return '';
    }
  }
}

export function getHexColorForMngColor(color: string): string {
  switch (color) {
    case 'info':
      return DEFAULT_ACCENT_COLOR;
    case 'warning':
      return DEFAULT_WARNING_COLOR;
    case 'error':
      return DEFAULT_ERROR_COLOR;
  }
}

function gvColor(asHexCode: boolean): string {
  if (asHexCode) {
    return '#498220';
  }
  return 'color5';
}

function lvColor(asHexCode: boolean): string {
  if (asHexCode) {
    return '#554B69';
  }
  return 'color3';
}

function uvColor(asHexCode: boolean): string {
  if (asHexCode) {
    return '#B58070';
  }
  return 'color4';
}

function svColor(asHexCode: boolean): string {
  if (asHexCode) {
    return '#708F9C';
  }
  return 'color0';
}
